import script from "./AssistentsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AssistentsView.vue?vue&type=script&setup=true&lang=js"

import "./AssistentsView.vue?vue&type=style&index=0&id=74d9f08e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74d9f08e"]])

export default __exports__